import React, { useState, useEffect } from "react";
import useStore from "./store";
import shallow from "zustand/shallow";
import Page from "./Page.jsx";
import EmailPdf from "../../email-pdf/jsx/email-pdf.jsx";
import axios from "axios";
import { checkSummaryPages, checkIfAssetHasOneChild } from "../js/Utils.js";
import OptionTooltip from "../../option-tooltip/jsx/option-tooltip.jsx";

function AppSWT() {
    const [isLoading, setIsLoading] = useState(true);

    const { setMatrixData, setCurrentId } = useStore(
        (state) => ({
            setMatrixData: state.setMatrixData,
            setCurrentId: state.setCurrentId,
        }),
        shallow
    );

    /* For local development */
    // setCurrentId("1085550");
    // return (
    //     <div className="app__wrapper">
    //         <Page />
    //         <EmailPdf />
    //         <OptionTooltip />
    //     </div>
    // );
    /* end for local development */

    /* For live */
    useEffect(() => {
        const decisionTreeUrl = document.getElementById(
            "decisionTree__app-wrapper"
        ).dataset.jsondata;
        axios.get(decisionTreeUrl).then((response) => {
            let data = response.data;
            setCurrentId(data["startPage"]);
            setMatrixData(data);
            setIsLoading(false);

            // Below are tests
            // These can be removed in production
            // checkSummaryPages(data);
            // checkIfAssetHasOneChild(data);
        });
    }, [setCurrentId, setMatrixData]);

    if (isLoading) {
        return (
            <div className="app__wrapper">
                <div className="decision_wrapper bg_cerulean">
                    <div className="decision_body decision_box">
                        <div>Please wait. Loading information...</div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="app__wrapper">
                <Page />
                <EmailPdf />
                <OptionTooltip />
            </div>
        );
    }
    /* end for live */
}

export default AppSWT;
